import { useAuthStore } from '@/common/stores/auth';

export default {
  name: 'Subscription Thanks',
  path: '/subscription-thanks',
  component: () => import('@/modules/subscription-thanks/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        content: 'Subscription Thanks.',
        name: 'description',
      },
      {
        page_slug: 'subscription-thanks',
      },
    ],
    requiresAuth: true,
    title: 'eRank — Subscription Thanks',
  },
  beforeEnter: async (to, from, next) => {
    const authStore = useAuthStore();

    if(authStore.user?.plan_id) {
      next();
    } else {
      window.location.href = `/dashboard`;
    }
  },
};